const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/agentMessage/list'], resolve),
  meta: {
    requireAuth: true
  }
}

export default list